export default __webpack_public_path__ + "static/N0290-6e75269cce70be72ce9370e63a5f3c41.png";